import React from "react";
import Header from "./Header";
import "../assets/styles/SelfieScreenOne.css";
import selfieCorrect from "../assets/images/selfie-correct.png";
import selfieWrong from "../assets/images/selfie-wrong.png";
import correct from "../assets/images/Check.svg";
import wrong from "../assets/images/Close.svg";
import { TOEFL_PROGRAM_ID } from "../constants/Constants";

const SelfieScreenOnce = ({ toNextPage }) => {
  const programId = sessionStorage.getItem("program_id");
  return (
    <div style={{ display: "flex", flexDirection: "column", height: "100vh" }}>
      <Header />
      <div className="selfie-screen-container">
        <h3>Before you continue</h3>
        <h4>You need:</h4>
        <ul>
          <li>Even lighting</li>
          <li>no shadows or glare on your face or behind you</li>
        </ul>
        <div className="selfie-img-inst-container">
          <div className="img-contaier">
            <img src={selfieCorrect} />
            <div>
              <p>
                <img src={correct} /> Even lighting and no shadow
              </p>
            </div>
          </div>
          <div className="img-container">
            <img src={selfieWrong} />
            <div>
              <p>
                <img src={wrong} /> Shadow behind head
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="button-container">
        <button
          className={`continue-button ${
            programId == TOEFL_PROGRAM_ID ? "toefl-button-bg" : "gre-button-bg"
          }`}
          onClick={toNextPage}
        >
          Continue
        </button>
      </div>
    </div>
  );
};

export default SelfieScreenOnce;
